import {useCallback} from 'react'
import {useAuthClient} from '../../../utils/use-auth-client'
import {buildPaymentPreviewPayload} from '../utils/buildPaymentPreviewPayload'
import {applyPaymentPreview} from '../utils/applyPaymentPreview'

// Reusable payment-preview trigger for any flow with a normalized item list
// (productCode/productType/quantity/addons). Callers pass their current
// selection; this hook owns building the request, calling the API, and
// mapping the response back onto the items. It does not know how the caller
// stores the result — callers persist the returned {items, dueTodayTotal,
// monthlyTotal} however their own state model needs.
//
// `cc/order/preview-payment` previews a change against an existing Recurly
// account (it looks the account up by thryvId and requires billing info on
// file) — it cannot price a brand-new account that doesn't exist yet. Skip
// the call entirely when there's no thryvId and leave the caller's items
// untouched, rather than sending a request guaranteed to fail.
export function usePaymentPreview() {
  const client = useAuthClient()

  const previewPayment = useCallback(
    async ({
      items,
      thryvId,
      country,
      coupons,
      productConfigInfo,
      isNewTLMCAccessible,
      frontendListingsBcMc,
    }) => {
      if (!items?.length || !thryvId) {
        return null
      }
      console.log('items: ', items)
      const payload = buildPaymentPreviewPayload({
        items,
        thryvId,
        country,
        coupons,
        productConfigInfo,
        isNewTLMCAccessible,
        frontendListingsBcMc,
      })
      try {
        const preview = await client('cc/order/preview-payment', {
          data: payload,
        })
        return applyPaymentPreview(items, preview, country)
      } catch (error) {
        if (error.message === 'Billing info missing on account') throw error
        return null
      }
    },
    [client],
  )

  return {previewPayment}
}
